import * as WorkJourney from './WorkJourney';

export default { WorkJourney };
